import { Link } from 'react-router-dom'
import { FaHome, FaExclamationTriangle } from 'react-icons/fa'
import { Button } from '../components/common'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-24 h-24 rounded-full bg-yellow-100 flex items-center justify-center mx-auto mb-6">
          <FaExclamationTriangle className="text-fluid-4xl text-yellow-500" />
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">页面未找到</h2>
        <p className="text-gray-500 mb-8 max-w-md">
          抱歉，您访问的页面不存在或已被移除。
        </p>
        <Link to="/">
          <Button icon={<FaHome />}>返回首页</Button>
        </Link>
      </div>
    </div>
  )
}
